/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import Swal from "sweetalert2";
import { CircularProgress } from "@material-ui/core";
import { getRequest, putRequest } from "utils/request";

import "./style.css";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { translate } from "../../translate/i18n";
import { useNotification } from "hooks/notification";
import { useModal } from "hooks/modal";
import exportExcel from "utils/exportExcel";
import format from "date-fns/format";

export default function Users({ history }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [onlyActive, setOnlyActive] = useState(true);
  const [update, setUpdate] = useState(0);
  const { selectedCompany } = useNotification();
  const [globalFilter, setGlobalFilter] = useState("");
  const [filter, setFilter] = useState("");
  const dt = useRef(null);
  const { toggleHelperId } = useModal();

  const getUsers = async () => {
    setLoading(true);

    //BUSCA USUÁRIOS DISPONIVEIS POR EMPRESA
    const ReturnGet = await getRequest(
      `/users/staff/${selectedCompany.id}?onlyActive=${onlyActive ? 1 : 0}`
    );
    if (ReturnGet.success) {
      ReturnGet.data.forEach((e) => {
        if (e.active === true) {
          e.active = translate("userActive");
        } else {
          e.active = translate("inactive");
        }
      });
      setUsers(ReturnGet.data);
      setLoading(false);
    }
  };

  const handleInativate = (id) => {
    Swal.fire({
      title: translate("attemption"),
      text: translate("deleteUser"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: translate("confirmEraseCompany"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        //INATIVA USUÁRIO
        const ReturnPut = await putRequest(`/users/inactivate/${id}`);
        if (ReturnPut.success) {
          setUpdate(update + 1);
        }
      }
    });
  };

  useEffect(() => {
    getUsers();
    setGlobalFilter("");
  }, [onlyActive]);

  const handleExport = () => {
    let data = [];

    users.forEach((e) => {
      const user = {
        ID: e.id,
        Login: e.login,
        [translate("name")]: e.name,
        [translate("nickname")]: e.nickName,
        [translate("document")]: e.document,
        "E-Mail": e.email,
        Status: e.active,
        [translate("language")]: e.language,
        [translate("createdAt")]: format(new Date(e.createdAt), "dd/MM/yyyy"),
      };
      data.push(user);
    });

    exportExcel(data, translate("user") + "s");
  };

  const header = (
    <div className="data-table-header">
      <div
        className="checkbox-container"
        style={{ position: "absolute", left: 10 }}
      >
        <input
          checked={onlyActive}
          onChange={() => setOnlyActive(!onlyActive)}
          type="checkbox"
          className="checkbox"
          style={{ marginRight: 10 }}
        />
        <label>{translate("showInactive")}</label>
      </div>
      <i className="pi pi-search" style={{ paddingRight: 10 }}></i>
      <input
        className="input-globalfilter"
        type="search"
        onChange={(e) => setFilter(e.target.value)}
        placeholder="Buscar"
        icon="pi pi-search"
      />
    </div>
  );

  const actionButtonsTemplate = (data) => {
    return (
      <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        <div
          className="action-icon"
          style={{ cursor: "pointer" }}
          onClick={() => history.push(`../../dashboard/newuser/${data.id}`)}
        >
          <i className="mdi mdi-pencil" style={{ fontSize: 20 }}></i>
        </div>
        <button
          className="action-icon"
          style={{
            cursor: "pointer",
            backgroundColor: "transparent",
            color: !data.active ? "rgba(73,80,87, 0.5)" : "#495057",
            border: "none",
          }}
          disabled={data.active === false}
          onClick={() => handleInativate(data.id)}
        >
          <i className="mdi mdi-delete" style={{ fontSize: 20 }}></i>
        </button>
      </div>
    );
  };

  const photoTemplate = (data) => {
    return (
      <img
        alt={data.name}
        className="image-perfil-avatar-customer"
        src={data.photo}
      ></img>
    );
  };

  useEffect(() => {
    if (filter.length < 3 && filter.length !== 0) {
      return;
    }
    const timeout = setTimeout(() => {
      setGlobalFilter(filter);
    }, 1000);
    return () => clearTimeout(timeout);
  }, [filter]);

  useEffect(() => {
    getUsers();
    toggleHelperId(4);
  }, [update]);

  return (
    <div className="col-12" style={{ overflowY: "auto" }}>
      <div className="card">
        <div className="card-body pt-1">
          <div className="area-header-table-users">
            <h4>{translate("user") + "s"}</h4>
            <button
              type="button"
              onClick={handleExport}
              className="export-excel"
            >
              <i
                style={{ fontSize: 16, marginRight: 5 }}
                className="pi pi-file-excel"
              />
              <span style={{ fontSize: "1vw" }}>
                {translate("exportAllData")}
              </span>
            </button>
          </div>
          {(!!selectedCompany.usersLimit ||
            selectedCompany.usersLimit === 0) && (
            <div className="users-limit-container">
              <h4 style={{ fontSize: "1.2vw" }}>
                {translate("newUserLimit") +
                  " " +
                  selectedCompany.usersLimit +
                  " " +
                  translate("user") +
                  "(s) " +
                  translate("simultaneously") +
                  ". " +
                  translate("contactSuport")}
              </h4>
            </div>
          )}
          <div className="tab-content">
            <div className="tab-pane show active" id="basic-datatable-preview">
              {!loading ? (
                <DataTable
                  globalFilter={globalFilter}
                  header={header}
                  dataKey="id"
                  rowsPerPageOptions={[25, 50, 100]}
                  value={users}
                  paginator
                  rows={25}
                  emptyMessage={translate("noUsersFound")}
                  ref={dt}
                >
                  <Column
                    body={photoTemplate}
                    field="photo"
                    header={translate("photo")}
                  ></Column>
                  <Column
                    field="name"
                    header={translate("name")}
                    sortable
                  ></Column>
                  <Column field="login" header="Login" sortable></Column>
                  <Column
                    header={translate("profile")}
                    field="UserType.description"
                    sortable
                  ></Column>
                  <Column
                    field="document"
                    header={translate("document")}
                  ></Column>
                  <Column field="email" header={translate("email")}></Column>
                  <Column field="active" header={translate("status")}></Column>
                  <Column
                    body={actionButtonsTemplate}
                    field="action"
                    header={translate("action")}
                  ></Column>
                </DataTable>
              ) : (
                <div className="area-loading">
                  <CircularProgress />
                </div>
              )}
            </div>
          </div>
          <button
            style={{
              border: "none",
              backgroundColor: "transparent",
              marginLeft: "auto",
            }}
            className="button-add-relative"
            onClick={() => history.push(`../../../dashboard/newuser`)}
            // disabled={
            //   (selectedCompany.usersLimit !== null || selectedCompany.usersLimit === 0) &&
            //   ((selectedCompany.usersLimit - users.length) < 1)
            // }
          >
            <i className="mdi mdi-plus"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
